import { ServiceType } from 'protocol/api/billing_new/dto_services_new_pb';

export const SERVICE_GROUP_2D_ANALYSIS = [
  ServiceType.ServiceType_Order_IOXRay_GP_Analysis,
  ServiceType.ServiceType_Order_Panoramic_GP_Analysis,
];

export const SERVICE_GROUP_3D_ANALYSIS = [
  ServiceType.ServiceType_Order_CBCT_GP_Analysis,
  ServiceType.ServiceType_Order_CBCT_Endodontic_Analysis,
  ServiceType.ServiceType_Order_CBCT_Implantology_Analysis,
  ServiceType.ServiceType_Order_CBCT_ThirdMolar_Analysis,
  ServiceType.ServiceType_Order_CBCT_STL_Analysis,
  ServiceType.ServiceType_Order_CBCT_Orthodontic_Analysis,
  ServiceType.ServiceType_Order_CBCT_IOS_Superimposition_Analysis,
  ServiceType.ServiceType_Order_IOS_Segmentation_Analysis,
  ServiceType.ServiceType_Order_ImplantStudio_Analysis,
  ServiceType.ServiceType_Order_OrthoStudio_Analysis,
];

export const SERVICE_ENABLE_ONLY = [
  ServiceType.ServiceType_Enable_DesktopApp,
  ServiceType.ServiceType_Enable_CollaborationTool,
  ServiceType.ServiceType_Enable_3DModelsWithConditions,
  ServiceType.ServiceType_Enable_SuggestedTreatment,
];

export const SERVICE_GROUP_2D_UPLOADS = [
  // WA-6209: upload counters removed; dental-photo upload survives as enabler.
  ServiceType.ServiceType_Enable_UploadDentalPhoto,
];

export const SERVICE_GROUP_3D_UPLOADS = [
  // WA-6209: uploads no longer metered; CBCT/STL upload counters removed with
  // no replacement.
];

export const SERVICE_GROUP_TRIAL = [
  ServiceType.ServiceType_Order_CBCT_STL_Analysis,
  ServiceType.ServiceType_Order_CBCT_Orthodontic_Analysis,
  ServiceType.ServiceType_Order_CBCT_IOS_Superimposition_Analysis,
  ServiceType.ServiceType_Order_ImplantStudio_Analysis,
];

export const ALL_SERVICES = [
  ...SERVICE_GROUP_2D_ANALYSIS,
  ...SERVICE_GROUP_3D_ANALYSIS,
  ...SERVICE_GROUP_2D_UPLOADS,
  ...SERVICE_GROUP_3D_UPLOADS,
  ...SERVICE_ENABLE_ONLY,
  ServiceType.ServiceType_Order_Transcriptor,
  ServiceType.ServiceType_Expand_Storage,
];

export const VISIBLE_SERVICES = [
  ...SERVICE_GROUP_2D_ANALYSIS,
  ...SERVICE_GROUP_3D_ANALYSIS,
  ...SERVICE_ENABLE_ONLY,
  ServiceType.ServiceType_Order_Transcriptor,
  ServiceType.ServiceType_Expand_Storage,
];
